import React from 'react';
import { RichTextField, FunctionField, DateField, Show, TextField } from 'react-admin';
import { Grid, GridShowLayout } from '../../components/wrapper';
import { gatewayRenderer } from './PaymentTransactionLogConstants';
import { JsonTextField, LinkField } from '../../components/fields';

const PaymentTransactionLogShow = props => (
	<Show {...props}>
		<GridShowLayout>
			<Grid container>
				<Grid item xs>
					<TextField source="id" />
					<DateField source="creationDateTime" />
					<DateField source="completionDateTime" />
					<TextField source="requestId" />
					<TextField source="status" />
					<TextField source="authorizationId" />
					<LinkField source="paymentTransactionId" type={'PaymentTransaction'} />
				</Grid>
				<Grid item xs>
					<FunctionField source="gatewayIdentifier" render={gatewayRenderer} />
					<TextField source="gatewayCall" />
					<TextField source="businessContractId" />
					<TextField source="retrievalReferenceNumber" />
					<TextField source="errorCode" />
					<TextField source="errorMessage" />
					<RichTextField source="additionalData" />
				</Grid>
			</Grid>
			<Grid container>
				<Grid item xs>
					<JsonTextField source="request" fullWidth />
				</Grid>
				<Grid item xs>
					<JsonTextField source="response" fullWidth />
				</Grid>
			</Grid>
		</GridShowLayout>
	</Show>
);

export default PaymentTransactionLogShow;
